export const KEY_SUITE = 'SUITE';
export const KEY_LOGIX  = 'CorrLogix';
export const KEY_MONITOR = 'CorrMonitor';
export const DEFAULT_KEY = KEY_SUITE;

const SUITE = {
	key: KEY_SUITE,
	tile: undefined,
	details: {
		title: 'Total Asset Awareness',
		details:
			"Protect the integrity of your assets with CorrproCanada's asset integrity apps. These focused web applications help you stay on top of asset status, make stronger decisions, plan more efficiently and stay responsive."
	}
};

const LOGIX = {
	key: KEY_LOGIX,
	tile: {
		name: 'CorrLogix',
		imageSrc: 'Content/Images/dot-net-images/icon_scanline.png',
		hero: 'CP Analytics',
		copy: 'Turn complex corrosion data into clear, actionable insights.'
	},
	details: {
		title: 'Advanced Corrosion Analysis & Action Planning.',
		details:
			'CorrLogix streamlines pipeline corrosion data analysis and automates action plans. With just a few clicks, users can identify issues, assign remediation tasks, and generate corrective action plans—faster than ever before.'
	}
};

const MONITOR = {
	key: KEY_MONITOR,
	tile: {
		name: 'CorrMonitor',
		imageSrc: 'Content/Images/dot-net-images/icon_assetview.png',
		hero: 'CP Survey',
		copy: 'Keeps your integrity management workflow simple, fast, and field-ready.'
	},
	details: {
		title: 'Real-Time Access to Surveyed Assets',
		details:
			'CorrMonitor delivers streamlined access to critical Cathodic Protection (CP) asset data, helping specialists stay efficient and informed—wherever they are.'
	}
};


export const applications = [
	LOGIX,
	MONITOR,
];

export const detailsMap = [SUITE, ...applications].reduce((acc, obj) => {
	return {
		...acc,
		[obj.key]: obj.details
	};
}, {});

export default {
	applications,
	detailsMap
};
